import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';
import _uniqueId from 'lodash/uniqueId';
import Linkify from 'linkifyjs/react';

interface NewLineTextProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  text?: string;
}

const ParagraphsText: FC<NewLineTextProps> = ({ text, ...props }) => {
  if (!text) return null;
  const newText = text.split('\n');
  return (
    <div {...props}>
      {newText.map((str) => (
        <Linkify key={_uniqueId('paragraph-')} tagName="p">
          {str}
        </Linkify>
      ))}
    </div>
  );
};

export default ParagraphsText;
